import { Component, Input, OnInit, inject } from "@angular/core";
import { FlexDirective, LayoutAlignDirective, LayoutDirective } from "@ngbracket/ngx-layout/flex";
import { ChartJsContainerComponent } from "@tylertech/chart-js";
import { ChartService } from "@tylertech/charting-module";
import { ForgeIconButtonModule, ForgeIconModule, ForgeTooltipModule } from "@tylertech/forge-angular";
import { IShellService } from "@tylertech/incode-module";
import { IntentService } from "@tylertech/intents-module";
import { ChartConfiguration } from "chart.js";
import { PacketProgress } from "../../../interfaces";

@Component({
    selector: "packet-progress-chart",
    templateUrl: "./packetProgressChart.tmpl.html",
    styleUrls: [
        "./packetProgressChart.component.scss"
    ],
    imports: [
        ChartJsContainerComponent,
        FlexDirective,
        LayoutAlignDirective,
        LayoutDirective,
        ForgeIconButtonModule,
        ForgeIconModule,
        ForgeTooltipModule,
    ]
})
export class PacketProgressChartComponent implements OnInit
{
    private readonly $shellService = inject(IShellService);
    private readonly $intentService = inject(IntentService);
    private readonly $chartService = inject(ChartService);

    chartConfig: ChartConfiguration<"bar">;

    @Input() item: PacketProgress;

    ngOnInit(): void
    {
        this.displayChart();
    }

    private displayChart(): void
    {
        const chartColor = this.$chartService.getColors(1)[0];
        this.chartConfig = {
            type: "bar",
            options: {
                maintainAspectRatio: false,
                indexAxis: "y",
                plugins: {
                    legend: { display: false },
                    tooltip: { enabled: false },
                },
                scales: {
                    x: {
                        type: "linear",
                        stacked: true,
                        grid: { display: true },
                        min: 0,
                        max: 100,
                        ticks: {
                            stepSize: 25,
                        },
                    },
                    y: { stacked: true },
                },
            },
            data: {
                labels: [],
                datasets: [{
                    data: [(this.item.CompletedSteps / this.item.TotalSteps) * 100],
                    backgroundColor: [chartColor],
                }],
            },
        };
    }

    openPacket(): void
    {
        if (this.$shellService.isEmbedded())
        {
            this.$shellService.openShellFunction("OpenProcessing", this.item.ProcessId, false, "Failed to open packet ");
        }
        else
        {
            this.$intentService.resolveIntent({
                MIME: "OpenProcessing",
                Action: "Open",
                Data: { ProcessId: this.item.ProcessId },
            }, true);
        }
    }
}
